import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=2be0dc94&scoped=true&"
import script from "./CompanyCard.vue?vue&type=script&lang=ts&"
export * from "./CompanyCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be0dc94",
  null
  
)

export default component.exports